import GeometryType from 'ol/geom/GeometryType';

import Mediator from 'gisw/Classes/Mediator';

/**
 * Get default attributes for a feature layer
 */
function getDefaultAttributes (layer: any) {
  const attributes = {};

  for (const type of layer.types) {
    pushTemplates(attributes, type.templates);
  }

  if (layer.templates.length > 0) {
    pushTemplates(attributes, layer.templates);
  }

  return attributes;
}

/**
 * Add the first value we find for each attribute
 */
function pushTemplates (attributes: any, templates: Array<any>) {
  if (!Array.isArray(templates)) {
    return;
  }

  for (const template of templates) {
    const keys = Object.keys(attributes);

    if (keys.length === 0) {
      Object.assign(attributes, template.prototype.attributes);
      continue;
    }

    for (const key of keys) {
      if (attributes[key] === null) {
        attributes[key] = template.prototype.attributes[key];
      }
    }
  }
}

/**
 * Get Server info
 */
export async function fetchSubFeature (url: string, token: string) {
  let results: any = null;

  try {
    results = await new Promise((resolve, reject) => {
      $.ajax({
        data: { f: 'json', token },
        dataType: 'json',
        url
      })
        .then(resolve)
        .catch(reject);
    });

    results.url = url;
    results.layerInfos = results.layers;

    // Feature Layers
    if (results.types) {
      results.defaultAttributes = getDefaultAttributes(results);
    }

    return results;
  } catch (err) {
    Mediator.jstManager.jstError('Tool', 'Editor', 'fetchSubFeature', err);
  }

  return results;
}

// eslint-disable-next-line no-undef
export function getDomInputType (type: Backend.FieldValueType) {
  switch (type) {
    case 'esriFieldTypeDouble':
    case 'esriFieldTypeInteger':
    case 'esriFieldTypeSingle':
    case 'esriFieldTypeSmallInteger':
    case 'esriFieldTypeOID':
      return 'number';

    case 'esriFieldTypeDate':
      return 'date';

    case 'esriFieldTypeString':
    default:
      return 'text';
  }
}

export function getFieldValue (
  // eslint-disable-next-line no-undef
  fieldInfo: Backend.FieldInfo,
  attribute: any = null
) {
  if (!attribute) {
    return fieldInfo.nullable ? null : fieldInfo.defaultValue;
  }

  if (getDomInputType(fieldInfo.type) === 'date') {
    return new Date(attribute);
  }

  return attribute;
}

/**
 * Get front end geometry type from backend geometry type
 */
export function getGeometryType (geometryType: string) {
  switch (geometryType) {
    case 'esriGeometryPoint':
      return GeometryType.POINT;
    case 'esriGeometryPolyline':
      return GeometryType.LINE_STRING;
    case 'esriGeometryPolygon':
      return GeometryType.POLYGON;
    default:
      return null;
  }
}
